import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';

export default function ForceMultiFactorAuth({ onChanged, value }) {
  const { i18n } = useTranslation();

  const handleChanged = (e) => {
    onChanged(e.target.checked);
  };
  return (
    <div className="container-fmfa">
      <div className="divider" />
      <h6>
        {i18n.t(`Obrigar todos os usuários a usar Autenticação de 2 Fatores`)}
      </h6>
      <p>
        {i18n.t(
          `Aumente o nível de segurança dos usuários fazendo com que usem autenticação de 2 Fatores.`
        )}
      </p>

      <div className="form-check">
        <input
          type="checkbox"
          disabled={false}
          checked={value}
          onChange={handleChanged}
          className="form-check-input"
          id="mfa-active"
        />
        <label className="form-check-label" htmlFor="mfa-active">
          {i18n.t('Ativar')}
        </label>
      </div>
    </div>
  );
}
